module.exports = __webpack_public_path__ + "img/jnv.703370be.jpg";